import React from 'react';
import classnames from 'classnames';

import defaultAvatar from 'asset/image/me_avatar_default@2x.png';
import styles from './index.module.scss';

interface IProps {
  src: string
  width?: number
  height?: number
}

const Avatar: React.FunctionComponent<IProps> = ({
  src,
}) => {

  return (<>
    <div className={!!src ? styles.imgBorder : styles.noImgBorder}>
      <img src={src || defaultAvatar} />
    </div>

  </>);
};

export default Avatar;
